import { useMemo } from 'react';

export default function useArrayHalves<T = unknown>(arr: T[]): [T[], T[]] {
  return useMemo(() => {
    const half = Math.ceil(arr.length / 2);
    return [arr.slice(0, half), arr.slice(half)];
  }, [arr]);
}
